/**
 * Cache keys owned by the shared query hooks.
 *
 * Values intentionally match the strings the apps already used, so an app's own
 * `CacheKey` entries and these stay interchangeable at runtime (both resolve to
 * the same string in the shared `QueryClient` cache). Two deliberate exceptions:
 *
 * - `LoadedMaritalStatus` — the apps previously keyed `loadMaritalStatus` either
 *   on `[]` (no key at all) or on `MaritalStatuses`, which collided with the
 *   `getMaritalStatuses` codebook query.
 *
 * - The address-codebook keys are named for the **lookup axis**, not the return
 *   type. Keying them `Settlement` / `Streets` put unrelated id spaces in one
 *   namespace — a street codebook id equal to the SLO country codebook id (204)
 *   made `[Settlement, '204']` mean both "settlements in Slovenia" and
 *   "settlements on street 204". Both sides return the same type, so the clash
 *   type-checks and surfaces only as wrong dropdown contents. `SettlementByPostZip`
 *   and `StreetsBySettlement` match the names the vendor app already uses.
 */
export enum CheckoutQueryKey {
    Country = 'Country',
    CurrencyInfo = 'CurrencyInfo',
    EmploymentType = 'EmploymentType',
    ExecutionAmounts = 'ExecutionAmounts',
    IndustryOfEmployment = 'IndustryOfEmployment',
    LoadedMaritalStatus = 'LoadedMaritalStatus',
    MaritalStatuses = 'MaritalStatuses',
    NumberOfConsecutivePaymentMonths = 'NumberOfConsecutivePaymentMonths',
    NumberOfRecentLoans = 'NumberOfRecentLoans',
    PostZip = 'PostZip',
    PostZipBySettlement = 'PostZipBySettlement',
    SettlementByPostZip = 'SettlementByPostZip',
    SettlementByStreet = 'SettlementByStreet',
    StreetsByPostZip = 'StreetsByPostZip',
    StreetsBySettlement = 'StreetsBySettlement',
    Time = 'Time',
}
